import { render, staticRenderFns } from "./OrdersServicesToSettlePopup.vue?vue&type=template&id=3611e7ac&scoped=true&"
import script from "./OrdersServicesToSettlePopup.vue?vue&type=script&lang=js&"
export * from "./OrdersServicesToSettlePopup.vue?vue&type=script&lang=js&"
import style0 from "./OrdersServicesToSettlePopup.vue?vue&type=style&index=0&id=3611e7ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3611e7ac",
  null
  
)

export default component.exports